"use client";
import React, { useState } from "react";
import { SignupForm } from "./SignupForm";

export const BuyButton = ({ color }: any) => {
    const [isOpen, setIsOpen] = useState(false);

    const openModal = () => {
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
    };
    return (
        <>
            <button
                onClick={openModal}
                className={`inline-flex items-center justify-center w-full h-12 px-6 mt-6 font-medium tracking-wide text-white transition duration-200 bg-${color}-400 rounded shadow-md hover:bg-${color}-700 focus:shadow-outline focus:outline-none`}
            >
                Cumpără
            </button>
            {isOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-white rounded-lg p-8 max-w-2xl mx-auto overflow-y-auto">
                        <div className="flex justify-between mb-4">
                            <h2 className="text-2xl font-bold">Inscriere Online</h2>
                            <button
                                className="text-gray-500 hover:text-gray-700"
                                onClick={closeModal}
                            >
                                Inchide
                            </button>
                        </div>
                        <div className="max-h-96 overflow-y-auto">
                            <SignupForm />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
